import { forwardRef } from "react";
import Link from "@mui/material/Link";
import Box, { BoxProps } from "@mui/material/Box";
import { RouterLink } from "@/routes/components";

export interface LogoProps extends BoxProps {
  disabledLink?: boolean;
}

const Logo = forwardRef<HTMLDivElement, LogoProps>(
  ({ disabledLink = false, sx, ...other }, ref) => {
    const logo = (
      <Box
        ref={ref}
        component="img"
        src="/assets/images/logo/hw.png"
        sx={{ width: 40, height: 40, cursor: "pointer", ...sx }}
        {...other}
      />
    );

    if (disabledLink) {
      return logo;
    }

    return (
      <Link component={RouterLink} href="/" sx={{ display: "contents" }}>
        {logo}
      </Link>
    );
  }
);

Logo.displayName = "Logo";

export default Logo;
